import React, { Fragment, useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import Breadcrumb from "../../../layout/breadcrumb";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import DatePicker from "../../../share-components/ui/DateRangePicker";
import PreLoader from "../../../share-components/ui/preLoader";
import withReducer from "../../../store/withReducer";
import partnerReducer from "../store";
import { getStatementReconciliation, getStatementReconsiliationSettings, setReconciliationVal } from "../store/partnerSlice";

const customStyles = {
  control: (base) => ({
    ...base,
    minHeight: 50,
    border: "none",
  }),
};

const customMultiStyles = {
  ...customStyles,

  multiValue: (base) => ({
    ...base,
    backgroundColor: "#656E78",
    color: "#fff",
    // borderRadius: "4px",
    padding: "2px 4px",
  }),

  multiValueLabel: (base) => ({
    ...base,
    color: "#fff",
    fontWeight: 500,
  }),

  multiValueRemove: (base) => ({
    ...base,
    color: "#fff",
    ":hover": {
      backgroundColor: "#333",
      color: "#fff",
    },
  }),
};

const statusOptions = [
  { value: 1, label: "Price Mismatch" },
  { value: 2, label: "Quantity Mismatch" },
  { value: 3, label: "Order Count Mismatch" },
];

function StatementReconciliation() {
  const partnerState = useSelector(({ partner }) => partner.partner);
  const TodayDate = new Date();
  const sevenDays = new Date().setDate(TodayDate.getDate() - 90);
  const [dateRange, setDateRange] = useState([sevenDays, TodayDate]);
  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [startDate, endDate] = dateRange;
  const [partner, setPartner] = useState();
  const [importedBy, setImportedBy] = useState();
  const [status, setStatus] = useState();

  const dataMenu = [
    {
      type: 0,
      text: "Statement Reconciliation",
      link: "",
    },
  ];

  useEffect(() => {
    dispatch(getStatementReconsiliationSettings()).then((res) => {
      dispatch(setReconciliationVal(res.payload));
    });
  }, [dispatch]);

  useEffect(() => {
    getData();
  }, [dispatch, page, pageSize, startDate, endDate, partner, importedBy, status]);

  const getData = () => {
    const data = {
      page,
      pageSize,
      start_date: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
      end_date: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
      partner_id: partner ? partner?.id : null,
      imported_by: importedBy ? importedBy?.id : null,
      status: status ? status : null,
    };

    setLoading(true);
    dispatch(getStatementReconciliation(data)).then((res) => {
      if (!res.error) {
        setLoading(false);
        setPageLoading(false);
      }
    });
  };

  const tableColumns = [
    {
      name: "Partner's Name",
      selector: (row) => row.partner_name,
      sortable: true,
      left: true,
    },
    {
      name: "Imported Date",
      selector: (row) => row.created_at,
      sortable: true,
      right: false,
    },
    {
      name: "Reconciliation Period",
      selector: (row) => {
        return `${row.start_date} - ${row.end_date}`;
      },
      sortable: true,
      left: true,
      width:"350px"
    },
    {
      name: "Imported By",
      selector: (row) => row.imported_by_name ?? "-",
      sortable: true,
      center: true,
    },
    {
      name: "Total MP Orders",
      selector: (row) => row.mp_total_records ?? "-",
      sortable: true,
      center: true,
    },
    {
      name: "Total Records in File",
      selector: (row) => row.total_records ?? "-",
      sortable: true,
      center: true,
    },
    {
      name: "Status",
      selector: (row) => (
        <div className="py-1">
          {row.status.length > 0 ? (
            row.status.map((s, i) => (
              <p
                key={i}
                style={{
                  color: "#FF3838",
                  fontWeight: 500,
                  marginBottom: 1,
                  marginTop: 1,
                }}
              >
                {s}
              </p>
            ))
          ) : (
            <p
              style={{
                color: "green",
                fontWeight: 500,
                marginBottom: 1,
                marginTop: 1,
              }}
            >
              No Mismatch
            </p>
          )}
        </div>
      ),
      sortable: true,
      left: true,
    },
    {
      name: "Imported File",
      selector: (row) => (
        <a href={row.file_path} target="_blank" rel="noopener noreferrer" style={{ fontSize: "22px", color: "#007bff" }}>
          <i className="fa fa-download"></i>
        </a>
      ),
      sortable: false,
      center: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <Link
          to={`/order/statement-reconciliation/${row.id}/details?partner=${row.partner_id}&batch=${row.id}&start_date=${moment(row.start_date).format(
            "YYYY-MM-DD"
          )}&end_date=${moment(row.end_date).format("YYYY-MM-DD")}`}
          style={{ fontSize: "22px", color: "#007bff" }}
        >
          <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
        </Link>
      ),
      sortable: true,
      center: true,
    },
  ];

  const pageChange = (e) => {
    setPage(e);
  };

  const onPageSizeChange = (e) => {
    setPage(1);
    setPageSize(e);
  };

  console.log("partnerState", partnerState);

  return (
    <Fragment>
      {pageLoading ? (
        <PreLoader />
      ) : (
        <>
          <Breadcrumb data={dataMenu} title="Statement Reconciliation" />
          <Container fluid={true}>
            <div className="product-grid">
              <div className="feature-products">
                <Card>
                  <Row>
                    <Col sm={4}>
                      <div className="dashboard-datepicker p-2">
                        <p style={{ marginBottom: 0, marginLeft: 17, fontSize: 16, fontWeight: 500, color: "#b0abab" }}>Imported Date</p>
                        <DatePicker
                          dateRange={dateRange}
                          dateRangeChange={(date) => {
                            setDateRange(date);
                          }}
                          defaultValue={[TodayDate, sevenDays]}
                          paddingLeft={0}
                        />
                      </div>
                    </Col>
                    <Col sm={8} className="d-flex align-items-center justify-content-end">
                      <div className="float-sm-right p-3">
                        <Link className="btn btn-sm btn-primary" to="/order/statement-reconciliation/upload-invoice">
                          Import Statements
                        </Link>
                      </div>
                    </Col>
                  </Row>
                </Card>

                <Row>
                  <Col>
                    <Select
                      placeholder={<div>Filter by Partner</div>}
                      className="select2-filter"
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      isClearable
                      cacheOptions
                      styles={customStyles}
                      options={partnerState.reconciliationSettings.partners}
                      onChange={(e) => {
                        setPartner(e ? e : null);
                      }}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </Col>
                  <Col>
                    <Select
                      placeholder={<div>Imported by</div>}
                      className="select2-filter"
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      isClearable
                      cacheOptions
                      styles={customStyles}
                      options={partnerState.reconciliationSettings.users}
                      onChange={(e) => {
                        setImportedBy(e ? e : null);
                      }}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </Col>
                  <Col>
                    <Select
                      placeholder="Select Status"
                      className="select2-filter"
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      isMulti
                      isClearable
                      options={partnerState.reconciliationSettings.status}
                      styles={customMultiStyles}
                      onChange={(selected) => {
                        console.log(selected);
                        setStatus(selected);
                      }}
                      components={{
                        IndicatorSeparator: () => null,
                      }}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col className="mt-4" sm="12">
                    <Card>
                      <CardBody>
                        {loading ? (
                          <div style={{ minHeight: 500 }}>
                            <PreLoader />
                          </div>
                        ) : (
                          <div className="table-responsive product-table">
                            <CommonDataTable
                              noAction
                              headerColumns={tableColumns}
                              gridData={partnerState.statementReconciliationData}
                              paginationTotalRows={partnerState.statementReconciliaitionTableRow}
                              paginationServer
                              onChangePage={pageChange}
                              onChangeRowsPerPage={onPageSizeChange}
                              paginationDefaultPage={page}
                              paginationPerPage={pageSize}
                            />
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        </>
      )}
    </Fragment>
  );
}

export default withReducer([{ partner: partnerReducer }])(StatementReconciliation);
